export type AppliedFilter = {
  key: string;
  label: string;
  onRemove: () => void;
};

export function AppliedFilters({ filters }: { filters: readonly AppliedFilter[] }) {
  return (
    <div className="applied-filters" aria-label="Applied filters">
      <span className="applied-filters-label">Applied filters</span>
      {filters.length ? (
        <div className="filter-chips">
          {filters.map((filter) => (
            <span className="chip chip-server" key={filter.key}>
              {filter.label}
              <button
                type="button"
                onClick={filter.onRemove}
                aria-label={`Remove filter ${filter.label}`}
              >
                ×
              </button>
            </span>
          ))}
        </div>
      ) : (
        <span className="applied-filters-empty">None</span>
      )}
    </div>
  );
}
